import React, {Component} from 'react';
import { Icon, Label} from 'semantic-ui-react';
import connect from "react-redux/es/connect/connect";
import {openModalIngredientStock} from "../../actions/ModalIngredientStockActions";

class StockIngredient extends Component {
    render() {
        return this.props.stock ?<Label as='a' color='orange' onClick={()=>this.props.openModalIngredientStock({is_open:true, data:this.props})}><Icon name='add'/> Actualizar Inventario</Label>:<Label>No Aplica</Label>;
    }
}

function mapDispatchToProps(dispatch){
    return {
        openModalIngredientStock(modal){
            dispatch(openModalIngredientStock(modal))
        },
    }
}

export default connect(
    null,
    mapDispatchToProps
)(StockIngredient)


// WEBPACK FOOTER //
// ./src/components/inventories/StockIngredient.js